const localesEs = {
  es: {
    translation: {
      COURSES_MENU: 'Aprende',
      COURSES_MENU_COURSES_TAB: 'Cursos',
      COURSES_MENU_COURSES_TAB_CATEGORIES: 'CATEGORÍAS',
      COURSES_MENU_COURSES_TAB_CATEGORIES_LINK: 'Ver todo',
      COURSES_MENU_COURSES_TAB_SUBCATEGORIES: 'SUBCATEGORÍAS',
      COURSES_MENU_COURSES_TAB_SUBCATEGORIES_LINK: 'Ver todo',
      COURSES_MENU_COURSES_TAB_NEW_COURSES: 'Cursos nuevos',
      COURSES_MENU_COURSES_TAB_FREE_COURSES: 'Cursos gratis',
      COURSES_MENU_CAREERS_TAB: 'Especializaciones',
      COURSES_MENU_CAREERS_TAB_LINK: 'Ver todas las especializaciones',
      COURSES_MENU_CERTI_TAB: 'Certificaciones',
      COURSES_MENU_CARD_SUFFIX: 'Cursos',
      COURSES_MENU_CERTI_TAB_CERTI_LINK: 'Ver todas las certificaciones',
      COURSES_MENU_PROMO_SECTION_CTA: 'Ver promoción',
      LIVES_LINK: 'Lives',
      COMMUNITY_MENU: 'Comunidad',
      COMMUNITY_MENU_LIVES: 'Lives',
      COMMUNITY_MENU_AFFILIATE: 'Panel de Afiliado',
      COMMUNITY_MENU_OPEN_COURSES: 'Cursos abiertos',
      COMMUNITY_MENU_RESOURCES: 'Recursos',
      COMMUNITY_MENU_COURSE_AGENDA: 'Agenda de Cursos',
      COMMUNITY_MENU_REMOTE_WORK: '#YoAprendoEnCasa',
      COMMUNITY_MENU_PROJECTS: 'Proyectos',
      COMMUNITY_MENU_BLOG: 'Blog',
      COMMUNITY_MENU_NEW_COURSES: 'Cursos Nuevos',
      COMMUNITY_MENU_COURSES_ON_OFFER: 'Cursos en Oferta',
      COMMUNITY_MENU_SEE_ALL: 'Ver todo',
      COOKIES_MESSAGE:
        'En Crehana utilizamos cookies para poder darte una mejor experiencia',
      BLOG_LINK: 'Blog',
      MEMBRESHIPS_LINK: 'Vuélvete Premium',
      MY_COURSES_LINK: 'Mis cursos',
      CART_MENU_EMPTY_TITLE1: '¡Oh no! 💔',
      CART_MENU_EMPTY_TITLE: 'Tu carrito está vacío',
      CART_MENU_EMPTY_CTA: 'Encuentra un curso ahora',
      CART_MENU_TITLE: 'Tienes {{number}} ítem en tu carrito',
      CART_MENU_TITLE_plural: 'Tienes {{number}} ítems en tu carrito',
      CART_MENU_TOTAL_LABEL: 'Total:',
      CART_MENU_GO_TO_CART_BUTTON: 'Ir a tu carrito',
      CART_MENU_BUY_NOW_BUTTON: 'Comprar ahora',
      MY_COURSES_MENU_TITLE: 'Últimos cursos vistos',
      MY_COURSES_MENU_SEE_ALL: 'Ir a mi panel',
      MY_COURSES_MENU_EMPTY_TITLE: 'Aún no te has inscrito a nuestros cursos',
      MY_COURSES_MENU_EMPTY_DESC:
        'No esperes más tiempo y potencia tus habilidades ahora.',
      MY_COURSES_MENU_EMPTY_CTA: 'Ir al catálogo',
      INBOX_MENU_TITLE: 'Chat de mentores',
      INBOX_MENU_SEE_ALL: 'Ver todos los mensajes',
      INBOX_MENU_EMPTY: 'Aún no inicias una conversación con nuestros mentores',
      INBOX_MENU_EMPTY_MENTOR: 'Aún no tienes mensajes',
      INBOX_MENU_EMPTY_ACTION: 'Ir al chat',
      INBOX_MENU_YESTERDAY: 'Ayer',
      INBOX_MENU_CHAT_STARTED: 'Inició una conversación',
      INBOX_MENU_CHAT_STARTED_BY_ME: 'Iniciaste una conversación',
      INBOX_MENU_IMAGE_SENT: 'Envió una imagen',
      INBOX_MENU_IMAGE_SENT_BY_ME: 'Enviaste una imagen',
      INBOX_MENU_FILE_SENT: 'Envió un archivo',
      INBOX_MENU_FILE_SENT_BY_ME: 'Enviaste un archivo',
      INBOX_MENU_ERROR: 'Ocurrió un error, inténtalo de nuevo más tarde.',
      NEWS_TITLE: 'Lo último en Crehana',
      NEWS_COURSES: 'Cursos',
      NEWS_COURSE_DETAIL: 'Ver detalle',
      NEWS_UPDATES: 'Updates',
      NEWS_ERROR: 'Ocurrió un error, inténtalo de nuevo más tarde.',
      NEWS_RETRY: 'Reintentar',
      NEWS_EMPTY:
        '¡Pronto descubrirás todas las novedades que tenemos para ti!',
      NEWS_COURSE_ERROR: 'Ver detalle',
      NEWS_POPPER_TITLE: 'Alerta de nuevos cursos',
      NEWS_POPPER_SUBTITLE:
        '¡No te pierdas los últimos lanzamientos de Crehana en esta nueva sección de notificaciones!',
      NEWS_POPPER_CTA: '¡Entendido!',
      TRACK_TAG: 'Especialización',
      NOTIFICATIONS_MENU_TITLE: 'Notificaciones',
      NOTIFICATIONS_MENU_GO_TO_DISCUSSION_LINK: 'Ir a la discusión',
      NOTIFICATIONS_MENU_GO_TO_PROFILE_LINK: 'Ir a perfil',
      NOTIFICATIONS_MENU_GO_TO_PROJECTS_LINK: 'Ver proyectos',
      NOTIFICATIONS_MENU_SEE_ALL_LINK: 'Ver todo',
      NOTIFICATIONS_MENU_EMPTY: 'Aún no tienes notificaciones',
      NOTIFICATIONS_MENU_ERROR:
        'Ocurrió un error al intentar recuperar tus notificaciones, intenta refrescar el navegador.',
      NAMES: 'Nombres',
      LAST_NAMES: 'Apellidos',
      CONTINUE: 'Continuar',
      USER_FORM_TITLE: '¡Ya estás a un paso!',
      USER_FORM_COPY:
        'Es importante para emitir tus diplomas y poder comunicarnos contigo',
      LATER: 'Lo haré después',
      PROFILE_MENU_MENTOR_PANNEL_LINK: 'Panel de mentor',
      PROFILE_MENU_MY_COURSES_LINK: 'Mis cursos',
      PROFILE_MENU_VIEW_PROFILE_LINK: 'Ver perfil',
      PROFILE_MENU_CONFIGURATION_LINK: 'Configuración',
      PROFILE_MENU_MY_MEMBERSHIP_LINK: 'Mi membresía',
      PROFILE_MENU_MEMBERSHIPS_LINK: 'Membresías',
      PROFILE_MENU_MENTORS_LINK: 'Mentores',
      PROFILE_MENU_PAYMENT_DASHBOARD_LINK: 'Payment Dashboard',
      PROFILE_MENU_LOGOUT_BUTTON: 'Cerrar sesión',
      LOGIN: 'Ingresar',
      REGISTER: 'Regístrate',
      MOBILE_COURSES_MENU: 'Cursos',
      MOBILE_COURSES_MENU_LINK: 'Ver todos los cursos',
      MOBILE_CAREERS_LINK: 'Carreras',
      MOBILE_NOTIFICATIONS_LINK: 'Notificaciones',
      MOBILE_TOOLS_LINK: 'Herramientas',
      MOBILE_EBOOKS_LINK: 'Ebooks',
      MOBILE_TUTORIALS_LINK: 'Tutoriales',
      MOBILE_TOP_CASES_LINK_LABEL: 'Top Cases',
      MOBILE_NEED_HELP_1: '¿Necesitas ayuda?',
      MOBILE_NEED_HELP_2: 'Aquí te atenderemos',
      LOGIN_CLEAN_HEADER: '¿Quieres conversar con nosotros?',
      LOGIN_TITLE: 'Bienvenido de Vuelta',
      LOGIN_SUBTITLE: 'Inicia sesión y aprende nuevas habilidades hoy.',
      LOGIN_FACEBOOK_LABEL: 'Continúa con Facebook',
      LOGIN_GOOGLE_LABEL: 'Continúa con Google',
      LOGIN_NOT_MEMBER: '¿Aún no eres miembro?',
      LOGIN_REGISTER: 'Regístrate',
      JOIN_FOR_FREE: 'Únete gratis',
      LOGIN_REGISTER_CONTINUE: 'o continúa con',
      LOGIN_REGISTER_CONTINUE_2: 'O crea una cuenta con',
      LOGIN_MAIN_BUTTON: 'Inicia Sesión',
      LOGIN_FORGET_PASSWORD: '¿Olvidaste tu contraseña?',
      LOGIN_PASSWORD: 'Contraseña',
      LOGIN_EMAIL: 'Usuario o Correo electrónico',
      LOGIN_REGISTER_CONDITIONS_1: 'Al registrarte aceptas nuestros',
      LOGIN_REGISTER_CONDITIONS_2: 'Términos',
      LOGIN_REGISTER_CONDITIONS_3: 'y',
      LOGIN_REGISTER_CONDITIONS_4: 'Políticas de Privacidad',
      LOGIN_REGISTER_CONDITIONS_5:
        'Recibe ofertas, nuevos cursos y noticias en tu correo',
      REGISTER_NOT_MEMBER: '¿Tienes una cuenta?',
      REGISTER_LOGIN: 'Inicia Sesión',
      REGISTER_TITLE: 'Únete hoy',
      REGISTER_SUBTITLE:
        'Sé parte de la nueva generación de profesionales digitales.',
      REGISTER_EMAIL: 'Correo electrónico',
      REFER_A_FRIEND: 'Refiere a un amigo',
      // CourseCard strings
      ADD_TO_CART: 'Añadir al carrito',
      ADDED_TO_CART: 'Agregado al carrito',
      REMOVE_FROM_CART: 'Quitar del carrito',
      GO_TO_COURSE: 'Ir al curso',
      SUBSCRIBE_FREE: '¡Inscríbete gratis!',
      SUBSCRIBE_NOW: '¡Inscríbete ahora!',
      TRY_COURSE: 'Pruébalo ahora',
      BUY_NOW: 'Comprar ahora',
      UPSELLING_ADD_ONE_ITEM: 'Tienes 1 ítem nuevo en tu carrito',
      UPSELLING_PACK_1: 'Hemos armado un pack de',
      UPSELLING_PACK_2: 'cursos para ti, llévatelo con',
      UPSELLING_EXPECTED: '¿No es lo que esperas?',
      UPSELLING_CUSTOM_PACK: 'Arma tu propio pack aquí',
      OFFERS_LINK: 'Promos',
      WISHLIST_EMPTY_TITLE: 'Tu lista de deseos está vacía',
      WISHLIST_EMPTY_DESCRIPTION: '¡Agrega un curso y obtén sorpresas!',
      // shopping cart component
      ACCUMULATIVE_DISCOUNT2: '¡Agrega el próximo curso con',
      SHOPPING_CART_TITLE: 'Tu carrito de compras',
      SHOPPING_CART_ACCESS: 'Ir a mi carrito',
      SHOPPING_CART_BUY: 'Comprar ahora',
      SHOOPPING_CART_QUANTITY_TEXT_1: 'Tienes ',
      SHOOPPING_CART_QUANTITY_TEXT_2: ' en tu carrito',
      AUTH_VALIDATION_REQUIRED: 'Campo requerido',
      LEGALS_TEXT_1: 'Acepto los ',
      LEGALS_TEXT_2: 'Términos, Condiciones y Políticas ',
      AUTH_VALIDATION_LEGALS_REQUIRED:
        'Debes aceptar los Términos, Condiciones y Políticas para continuar.',
      AUTH_VALIDATION_PASSWORD_LENGTH:
        'Tu contraseña debe de tener entre 6 y 20 caracteres',
      AUTH_VALIDATION_USER_LENGTH:
        'El campo usuario debe tener entre 6 y 75 caracteres',
      AUTH_VALIDATION_VALID_EMAIL: 'Ingresa una dirección de correo válida',
      AUTH_CONFIRMATION_EMAIL: 'Los correos electrónicos no coinciden',
      // bottom banner
      DISCOUNT_BAR_MESSAGE:
        'TE QUEDAN {{days}} DIAS PARA USAR TU {{percentage}} DTO. Y COMENZAR A APRENDER',
      DISCOUNT_BAR_MESSAGE_MOBILE:
        'TE QUEDAN {{days}} DIAS PARA USAR TU {{percentage}} DTO.',
      GIFT_MEMBERSHIP_MOBILE:
        '¡Te quedan {{days}} días para regalar una membresía anual!',
      GIFT_MEMBERSHIP_DESKTOP:
        'Te quedan {{days}} dias para regalar una membresía anual a quién tú quieras! ENVIAR REGALO',
      // Floating shopping cart reminder
      FLOATING_SHOPPING_CART_REMINDER_TITLE: '¿Te olvidaste de algo?',
      FLOATING_SHOPPING_CART_REMINDER_SUBTITLE:
        'Tienes {{coursesLength}} cursos en tu carrito.',
      FLOATING_SHOPPING_CART_REMINDER_LINK: 'Ver más',
      // Membership promo banner
      GIFT_MEMBERSHIP_BANNER_MESSAGE:
        '#YoAprendoEnCasa: Ahora la Membresía Premium es para dos',
      GIFT_MEMBERSHIP_BANNER_SHORT_MESSAGE:
        '#YoAprendoEnCasa: Premium es para dos',
      AUTH_DIALOG_MOBILE_HEADER_TITLE: 'Únete hoy',
      AUTH_DIALOG_MOBILE_HEADER_SUBTITLE:
        'Vive la mejor experiencia de aprendizaje creativa y digital.',
      AUTH_DIALOG_MOBILE_HEADER_TITLE_PROMO: '¡Estás a un paso de empezar!',
      AUTH_DIALOG_MOBILE_HEADER_SUBTITLE_PROMO:
        'Regístrate y accede a los cursos gratuitos de Crehana',
      BECOME_PREMIUM: 'Aprovecha',
      BECOME_PREMIUM_DESCRIPTION: ' Accede a todos estos cursos con rebajas',
      // Auth extra data form
      AUTH_EXTRA_DATA_FORM_TITLE: 'Llévanos contigo',
      AUTH_EXTRA_DATA_FORM_SUBTITLE:
        'Esta información servirá para darle seguimiento al progreso de tus cursos, y conocer tu experiencia en la plataforma',
      START: 'Empezar',
      // Membership renovation dialog
      DONT_LOSE_YOUR_BENEFITS:
        '¡No pierdas tus beneficios! Tu membresía vencerá en {{days}} día{{plural}}.',
      YOU_NEED_A_CARD: 'Necesitas asociar una tarjeta',
      YOU_HAVE_SAVED_CARD: 'Tienes una tarjeta guardada',
      WHICH_CARD_DO_YOU_WANT_TO_USE: '¿Con qué tarjeta deseas renovar?',
      ADD_ANOTHER_CARD: 'Agregar otra tarjeta',
      CONFIRM: 'Confirmar',
      ADD_NEW_CARD: 'Agrega tu nueva tarjeta',
      SECURITY_CODE: 'Código de seguridad',
      EXPIRATION_DATE: 'Fecha de caducidad',
      CREDIT_CARD_NUMBER: 'Número de la tarjeta de crédito',
      BACK: 'Regresar',
      REACTIVATE_MEMBERSHIP: 'Reactivar membresía',
      THANKS_FOR_BE_PART_OF_OUR_PREMIUM_COMMUNITY:
        'Gracias por formar parte de nuestra comunidad Premium',
      YOUR_MEMBERSHIP_STAYS_WITH_YOU_AS_MUCH_AS_YOU_WANT:
        'Tu membresía se quedará contigo el tiempo que la necesites, sigue disfrutando de todos tus beneficios.',
      ACCEPT: 'Aceptar',
      ACTIVATE_RENOVATION: 'Activar renovación',
      RENEW_WITH_CURRENT_CARD:
        'Confirma si deseas renovar tu membresía con la tarjeta *{{cardNumber}}',
      ASOCIATE_NEW_CARD:
        'Asocia una tarjeta a tu cuenta para activar la renovación de tu membresía',
      REQUIRED_CARD: 'El número de tu tarjeta obligatorio',
      CVC_CVV: 'CVC/CVV',
      REQUIRED_DATE: 'La fecha es obligatoria',
      REQUIRED_CVC: 'CVC/CVV obligatorio',
      INVALID_NUMBER: 'Tu tarjeta es inválida, intenta de nuevo',
      INVALID_DATE: 'Ingresa una fecha válida',
      ERROR_SAVE:
        'No se ha podido guardar tu tarjeta. Te recomendamos comunicarte con tu banco para más detalles.',
      INCORRECT_CVC: 'CVC/CVV incorrecto',
      CATCH_MESSAGE: 'No se ha podido guardar tu tarjeta, inténtalo otra vez',
      DATE_FORMAT: 'MM/YY',
      INVALID_DATE_FORMAT: 'Ingresa una fecha válida',
      DONT_WORRY_WE_DONT_SHARE_YOUR_DATA:
        'Descuida, no lo compartiremos con nadie.',
      // Aside
      YOU_ARE_ABOUT_TO_START: 'Estás a un paso de empezar',
      GET: 'Obtén',
      FREE: ' gratis ',
      COURSES_AND_RESOURCES:
        'acceso a cursos, Lives, recursos descargables y mucho más.',
      ACCEPT_COOKIES: 'Entiendo',
      SOCIAL_BUTTON_TEXT: 'Regístrate con',
      SOCIAL_BUTTON_TEXT_LOGIN: 'Inicia Sesión con ',
      B2B_TITLE: 'PARA EMPRESAS',
      COURSE_FREE: 'Cursos Gratis',
    },
  },
};

export default localesEs;
